import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Card, CardHeader, CardBody } from "../../../../_metronic/_partials/controls";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import axios from "axios";
import { CircularProgress } from "@material-ui/core";
import { showSuccessSnackbar } from "../../snackBar/snackBar.action";
import { Row, Col } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import { useIsAccessAllow } from "../../users/redux";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

const initialState = {
  ELEVENLABS_API_URL: "",
  ELEVENLABS_AGENT_ID: "",
  ELEVENLABS_AGENT_ID_AGENT_2: "",
  ELEVENLABS_PHONE_NUMBER_ID: "",
  ELEVENLABS_API_KEY: "",
  RESTRICTED_COUNTRY_CODES: "",
  STATIC_ALLOWED_NUMBERS: "",
  ReCallTimeSeconds: "",
  ReCallAttempts: "",
  RECALL_TEXT_FIND: "",
  RECALL_WRONG_NUMBER_MESSAGE: "",
};

const arrayToTextarea = (value) =>
  Array.isArray(value) ? value.join("\n") : "";

const textareaToArray = (value) =>
  value
    .split(/[\n,]+/)
    .map((item) => item.trim())
    .filter(Boolean);

const mapResponseToState = (payload) => ({
  ELEVENLABS_API_URL: payload?.ELEVENLABS_API_URL || "",
  ELEVENLABS_AGENT_ID: payload?.ELEVENLABS_AGENT_ID || "",
  ELEVENLABS_COLD_LEADS_CALLING_AGENT_ID: payload?.ELEVENLABS_COLD_LEADS_CALLING_AGENT_ID || "",
  ELEVENLABS_PHONE_NUMBER_ID: payload?.ELEVENLABS_PHONE_NUMBER_ID || "",
  ELEVENLABS_API_KEY: payload?.ELEVENLABS_API_KEY || "",
  RESTRICTED_COUNTRY_CODES: arrayToTextarea(payload?.RESTRICTED_COUNTRY_CODES),
  STATIC_ALLOWED_NUMBERS: arrayToTextarea(payload?.STATIC_ALLOWED_NUMBERS),
  ReCallTimeSeconds:
    payload?.ReCallTimeSeconds === undefined || payload?.ReCallTimeSeconds === null
      ? ""
      : String(payload.ReCallTimeSeconds),
  ReCallAttempts:
    payload?.ReCallAttempts === undefined || payload?.ReCallAttempts === null
      ? ""
      : String(payload.ReCallAttempts),
  RECALL_TEXT_FIND: payload?.RECALL_TEXT_FIND || "",
  RECALL_WRONG_NUMBER_MESSAGE: payload?.RECALL_WRONG_NUMBER_MESSAGE || "",
});

const mapStateToRequest = (state) => ({
  ELEVENLABS_API_URL: state.ELEVENLABS_API_URL.trim(),
  ELEVENLABS_AGENT_ID: state.ELEVENLABS_AGENT_ID.trim(),
  ELEVENLABS_COLD_LEADS_CALLING_AGENT_ID: state.ELEVENLABS_COLD_LEADS_CALLING_AGENT_ID.trim(),
  ELEVENLABS_PHONE_NUMBER_ID: state.ELEVENLABS_PHONE_NUMBER_ID.trim(),
  ELEVENLABS_API_KEY: state.ELEVENLABS_API_KEY.trim(),
  RESTRICTED_COUNTRY_CODES: textareaToArray(state.RESTRICTED_COUNTRY_CODES),
  STATIC_ALLOWED_NUMBERS: textareaToArray(state.STATIC_ALLOWED_NUMBERS),
  ReCallTimeSeconds: Number(state.ReCallTimeSeconds) || 0,
  ReCallAttempts: Number(state.ReCallAttempts) || 0,
  RECALL_TEXT_FIND: state.RECALL_TEXT_FIND.trim(),
  RECALL_WRONG_NUMBER_MESSAGE: state.RECALL_WRONG_NUMBER_MESSAGE.trim(),
});

const fieldDefinitions = [
  {
    key: "ELEVENLABS_API_URL",
    label: "ElevenLabs API URL",
    type: "text",
    placeholder: "https://api.elevenlabs.io/…",
    column: 6,
  },
  {
    key: "ELEVENLABS_AGENT_ID",
    label: "Agent-1: (Form Inquiry Calling)",
    type: "text",
    placeholder: "agent_…",
    column: 6,
  },
  {
    key: "ELEVENLABS_COLD_LEADS_CALLING_AGENT_ID",
    label: "Agent-2: (Candidates Master)",
    type: "text",
    placeholder: "agent_…",
    column: 6,
  },
  {
    key: "ELEVENLABS_PHONE_NUMBER_ID",
    label: "ElevenLabs Phone Number ID",
    type: "text",
    placeholder: "phnum_…",
    column: 6,
  },
  {
    key: "ELEVENLABS_API_KEY",
    label: "ElevenLabs API Key",
    type: "text",
    placeholder: "sk_…",
    column: 6,
  },
  {
    key: "RESTRICTED_COUNTRY_CODES",
    label: "Restricted Country Codes",
    //type: "textarea",
    type: "text",
    helpText: "Enter one per line (e.g. +91)",
    // rows: 4,
    // column: 12,
    column: 6,
  },
  {
    key: "STATIC_ALLOWED_NUMBERS",
    label: "Static Allowed Numbers",
    type: "textarea",
    helpText: "Enter one per line (e.g. +919898950065)",
    rows: 6,
    column: 12,
  },
  {
    key: "ReCallTimeSeconds",
    label: "Recall Time (seconds)",
    type: "number",
    min: 0,
    column: 6,
  },
  {
    key: "ReCallAttempts",
    label: "Recall Attempts",
    type: "number",
    min: 0,
    column: 6,
  },
  {
    key: "RECALL_TEXT_FIND",
    label: "Recall Text Find",
    type: "textarea",
    rows: 3,
    column: 12,
  },
  {
    key: "RECALL_WRONG_NUMBER_MESSAGE",
    label: "Recall Wrong Number Message",
    type: "textarea",
    rows: 3,
    column: 12,
  },
];

const SettingsPage = () => {
  const dispatch = useDispatch();
  const { adminBaseURL } = useSelector(
    (state) => state.environnment.environmentLists,
    shallowEqual
  );
  const history = useHistory();
  const canEdit = useIsAccessAllow("settings.edit_settings");

  const [formState, setFormState] = useState(initialState);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  const handleChange = useCallback((key) => {
    return (event) => {
      const value = event.target.value;
      setFormState((prev) => ({
        ...prev,
        [key]: value,
      }));
    };
  }, []);

  const fetchSettings = useCallback(async () => {
    if (!adminBaseURL) {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    try {
      const { data } = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/settings`,
        headers: { "Content-Type": "application/json" },
      });

      const payload = data?.data || data;
      if (payload) {
        console.log("payload===============>", payload);
        setFormState(mapResponseToState(payload));
      } else {
        dispatch(
          showSuccessSnackbar(
            "error",
            data?.message || "Unable to load settings",
            3000
          )
        );
      }
    } catch (error) {
      console.error("Failed to fetch settings", error);
      dispatch(
        showSuccessSnackbar("error", "Failed to load settings", 3000)
      );
    } finally {
      setIsLoading(false);
    }
  }, [adminBaseURL, dispatch]);

  const handleSubmit = useCallback(
    async (event) => {
      event.preventDefault();
      if (!canEdit) {
        dispatch(
          showSuccessSnackbar(
            "error",
            "You don't have permission to update settings",
            3000
          )
        );
        return;
      }
      setIsSaving(true);
      try {
        const payload = mapStateToRequest(formState);
        const { data } = await axios({
          method: "PUT",
          url: `${process.env.REACT_APP_HOST}${adminBaseURL}/settings`,
          headers: { "Content-Type": "application/json" },
          data: payload,
        });

        if (data?.code === 200 || data?.success || data?.status === 200) {
          dispatch(
            showSuccessSnackbar(
              "success",
              data?.message || "Settings updated successfully",
              3000
            )
          );
          await fetchSettings();
        } else {
          dispatch(
            showSuccessSnackbar(
              "error",
              data?.message || "Failed to update settings",
              3000
            )
          );
        }
      } catch (error) {
        console.error("Failed to update settings", error);
        dispatch(
          showSuccessSnackbar("error", "Failed to update settings", 3000)
        );
      } finally {
        setIsSaving(false);
      }
    },
    [adminBaseURL, dispatch, fetchSettings, formState, canEdit]
  );

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  const settingsFields = useMemo(() => fieldDefinitions, []);

  return (
    <Card className="shadow-sm">
      <CardHeader
        title={
          <div className="form-group m-0 d-flex align-items-center">
            <Link className="btn btn-link px-0" to="/dashboard">
              <SVG
                className="h-50 align-self-center"
                src={toAbsoluteUrl("/media/svg/icons/Navigation/Arrow-left.svg")}
              />
              Back
            </Link>
            <span className="pl-2">Settings</span>
          </div>
        }
      ></CardHeader>
      <CardBody>
        {isLoading ? (
          <div className="text-center py-10">
            <CircularProgress />
          </div>
        ) : (
          <form id="settings-form" onSubmit={handleSubmit}>
            <Row className="justify-content-center">
              <Col lg={8} md={10} sm={12}>
                <Row>
                  {settingsFields.map((field) => (
                    <Col md={field.column || 12} className="mb-4" key={field.key}>
                      <label className="form-label" htmlFor={field.key}>
                        {field.label}
                      </label>
                      {field.type === "textarea" ? (
                        <textarea
                          id={field.key}
                          className="form-control re_inputRouded"
                          rows={field.rows || 4}
                          value={formState[field.key]}
                          onChange={handleChange(field.key)}
                          placeholder={field.placeholder}
                          disabled={!canEdit}
                        />
                      ) : (
                        <input
                          id={field.key}
                          type={field.type}
                          className="form-control re_inputRouded"
                          value={formState[field.key]}
                          onChange={handleChange(field.key)}
                          placeholder={field.placeholder}
                          min={field.min}
                          disabled={!canEdit}
                        />
                      )}
                      {field.helpText && (
                        <small className="form-text text-muted d-block">
                          {field.helpText}
                        </small>
                      )}
                    </Col>
                  ))}
                </Row>

                <div className="form-group d-flex flex-wrap justify-content-center align-items-center mb-0 mt-5">
                  <div className="mr-4 mb-2">
                    <button
                      type="button"
                      className="btn btn-outline-blue"
                      onClick={() => history.goBack()}
                    >
                      Close
                    </button>
                  </div>
                  {canEdit && (
                  <div className="mb-2">
                    <button
                      type="submit"
                      className="btn btn-blue px-5"
                      disabled={isSaving || !canEdit}
                    >
                      {isSaving ? (
                        <span className="d-flex align-items-center">
                          <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                          Saving...
                        </span>
                      ) : (
                        "Update"
                      )}
                    </button>
                  </div>
                  )}
                </div>
              </Col>
            </Row>
          </form>
        )}
      </CardBody>
    </Card>
  );
};

export default SettingsPage;

